module.exports = __webpack_public_path__ + "static/media/step_5_loading.17cf67b7.mp3";